const Menu = (function () {
  return {
    render: (menu, lang) => {
      console.log(menu)
      return `
        <div class="itallap">
          <h1>${lang === "hu" ? "Mai étlap" : "Today's menu"}</h1>
          <div class="content">
            <table>
              <tr>
                <td class="title">${lang === "hu" ? "Előételek" : "Starters"}</td>
                <td>Ft</td>
              </tr>
            ${
              menu.starters[lang].map((item) => `<tr><td>${item.name}</td><td>${item.price ? item.price : ""}</td></tr>`).join("")
            }
              <tr>
                <td class="title">${lang === "hu" ? "Főételek" : "Main courses"}</td>
                <td>Ft</td>
              </tr>
            ${
              menu.main[lang].map((item) => `<tr><td>${item.name}</td><td>${item.price ? item.price : ""}</td></tr>`).join("")
            }
              <tr>
                <td class="title">${lang === "hu" ? "Desszertek" : "Desserts"}</td>
                <td>Ft</td>
              </tr>
            ${
              menu.desserts[lang].map((item) => `<tr><td>${item.name}</td><td>${item.price ? item.price : ""}</td></tr>`).join("")
            }
            </table>
          </div>
        </div>
      `
    }
  }
})();

export default Menu;


// WEBPACK FOOTER //
// ./src/Menu.js